import React, { useContext, useState } from "react";
import { ProjectContext } from "../../ProjectContext";

export default function SuperElite() {
  const {
    account,
    copyaddress,
    connectMetamask,
    toastError,
    toastSuccess,
    getsmcs,
    formatAddress,
    stakcontract_selite,
    settings,
    esigner,
    ethers,
  } = useContext(ProjectContext);
  const [amount, setamount] = useState(1);
  const [trdone, settrdone] = useState(false);
  const [hash, sethash] = useState("");

  const increment = () => {
    setamount(amount + 1);
  };

  const decrement = () => {
    var value = amount - 1;
    setamount(value <= 1 ? 1 : value);
  };
  const butNft = async () => {
    if (!account) {
      connectMetamask();
      toastError("Connect first");
      settrdone(false);
      return;
    }
    let token_contract = new ethers.Contract(
      settings.token,
      settings.tokenAbi,
      esigner
    );
    const allowance = await token_contract.allowance(
      account,
      settings.sEliteAddress
    );
    settrdone(true);
    async function main() {
      // var gsl = await stakcontract//   .stake(ethers.utils.parseEther(`${amount}`), incappass, referral)
      //   .estimateGas( { from: account, value: `${Number(calcstakingfee) + 1000000000}` });
      //   console.log("gasghd ",gsl,await ethers.eth.getGasPrice()
      //   );

      try {
        var stk = await stakcontract_selite.mintNFT(amount);
        const receipt = await stk.wait();
        // const randomHash = Array.from(crypto.getRandomValues(new Uint8Array(16))).map(byte => byte.toString(16).padStart(2, '0')).join('');
        sethash(receipt.transactionHash);
        toastSuccess("Transaction confirmed");
        // sethash(randomHash);
        getsmcs();
        settrdone(false);
      } catch (error) {
        console.log(error);
        toastError("Transaction declined");
        settrdone(false);
        return;
      }
    }

    if (Number(ethers.utils.formatEther(allowance)) < amount) {
      // if (false) {
      try {
        var approv = await token_contract.approve(
          settings.sEliteAddress,
          ethers.utils.parseEther("100000000")
        );
        const receipt = await approv.wait();
        console.log(receipt);
        toastSuccess("Token Approved");
        main();
      } catch (error) {
        console.log("error", error);
        toastError("Token not approved");
        settrdone(false);
        return;
      }
    } else {
      main();
    }
  };

  return (
    <>
      <div className="tp-shop-details-2-area tp-product-details-2-style pt-50">
        <div className="container container-1300">
          <div className="row align-items-start">
            <div className="col-xl-6 col-lg-6">
              <div className="tp-shop-details-right-wrap">
                <div className="tp-shop-details-categories">
                  {/* <span>Mens • Running</span> */}
                </div>
                <h4 className="tp-shop-details-title text-yellow-new">
                  Kryptogram SuperElite NFT ( 200 NFTs )
                </h4>
                <div className="tp-shop-details-inventory d-flex align-items-center">
                  <div className="tp-shop-details-price">
                    <span> Exclusive to selected buyers</span>
                  </div>
                  <div className="tp-shop-details-ratting-wrap d-flex align-items-center"></div>
                </div>
                <div className="tp-shop-details-msg ">
                  <ul>
                    <li>
                      <h4 className="tp-shop-details-title-sm">
                        VIP Entry to Tribe O Crypto Festival
                      </h4>
                    </li>
                    <li>
                      <h4 className="tp-shop-details-title-sm">
                        Personalized Helicopter Transfers
                      </h4>
                    </li>
                    <li>
                      <h4 className="tp-shop-details-title-sm">
                        Private Lounges & Luxury Hospitality
                      </h4>
                    </li>
                    <li>
                      <h4 className="tp-shop-details-title-sm">
                        Exclusive Networking Events & Premium Seating
                      </h4>
                    </li>
                  </ul>
                </div>
                <div className="text-light text-yellow-new">
                  <h2>Buy at {25500 * amount} USDT</h2>
                </div>
                <div className="tp-shop-details-action-box  mb-40 d-flex align-items-center pt-xxl-5">
                  {!trdone ? (
                    <>
                      <div className="tp-shop-details-quantity">
                        <span className="tp-cart-minus" onClick={decrement}>
                          <svg
                            width={11}
                            height={2}
                            viewBox="0 0 11 2"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1H10"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <input
                          className="tp-cart-input"
                          type="text"
                          defaultValue={amount}
                          value={amount}
                        />
                        <span
                          className="tp-cart-plus"
                          onClick={() => increment()}
                        >
                          <svg
                            width={11}
                            height={12}
                            viewBox="0 0 11 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 6H10"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M5.5 10.5V1.5"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                      <div className="tp-shop-details-btn-box d-flex align-items-center">
                        <button className="tp-btn-cart mr-10" onClick={butNft}>
                          Buy Now
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="d-flex align-items-center">
                      <img
                        src="assets/img/loader.gif"
                        alt=""
                        srcset=""
                        style={{ height: "90px" }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="tp-product-details-thumb-wrapper tp-tab">
                <div
                  className="tab-content m-img mb-20"
                  id="productDetailsNavContent"
                >
                  <div
                    className="tab-pane fade show active"
                    id="nav-1"
                    role="tabpanel"
                    aria-labelledby="nav-1-tab"
                    tabIndex={0}
                  >
                    <div className="tp-product-details-nav-main-thumb">
                      <video
                        muted
                        autoPlay
                        loop
                        id="myVideo"
                        className="video w-50"
                      >
                        <source
                          src="assets/img/one/super_elite.mp4"
                          type="video/mp4"
                        />
                      </video>
                      {/* <img
                        style={{ width: "60%" }}
                        src="assets/img/one/super_elite.gif"
                      /> */}
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="nav-2"
                    role="tabpanel"
                    aria-labelledby="nav-2-tab"
                    tabIndex={0}
                  >
                    <div className="tp-product-details-nav-main-thumb">
                      <img
                        className="w-100"
                        src="assets/img/inner-shop/shop-details/tab-img/tab-2.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
